import React from "react";
// import Particles from "react-particles-js";
import ParticlesBg from "particles-bg";

let config = {
  num: [4, 7],
  rps: 0.1,
  radius: [5, 40],
  life: [1.5, 3],
  v: [2, 3],
  tha: [-40, 40],
  alpha: [0.6, 0],
  scale: [.1, 0.4],
  position: "all",
  color: ["random", "#FF6700", "#F2B5F7", "#C4ED74"],
  cross: "dead",
  // emitter: "follow",
  random: 15
};

if (Math.random() > 0.85) {
  config = Object.assign(config, {
    onParticleUpdate: (ctx, particle) => {
      ctx.beginPath();
      ctx.rect(
        particle.p.x,
        particle.p.y,
        particle.radius * 2,
        particle.radius * 2
      );
      ctx.fillStyle = particle.color;
      ctx.fill();
      ctx.closePath();
    }
  });
}

const ParticleComponent = () => (
  <div
    style={{
      backgroundColor: "#0B0C10",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%"
    }}
  >
    <ParticlesBg type="custom" config={config} bg={true} />
  </div>
)

export default ParticleComponent;